import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel,IonPage, IonRow, IonThumbnail, IonTitle, IonToolbar, useIonViewWillEnter, useIonViewWillLeave } from "@ionic/react"
import React, { useEffect, useCallback } from "react"
import { useTranslation } from "react-i18next";
import { ebioroApi } from "../../services/api/ebioro/ebioro";
import { useAppDispatch, useAppSelector } from "../../services/redux/hook";
import { TopUpProvider } from "../../types/types";
import * as Sentry from '@sentry/react';
import './Topup.css'
import { setTopUpProviders } from "../../services/redux/slices/topup_providers/topup_providers";
import { setSeletedTopUpProvider } from "../../services/redux/slices/topup_provider_selected/selected_topup_provider";
import { arrowBackOutline, closeOutline } from "ionicons/icons";
import TopupProduct from "./TopupProduct";
import { Provider } from "react-redux";
import { store } from "../../services/redux/store";
import { closeModal } from "../../services/redux/slices/opened_navigation_modal/opened_root_modal";

const Page: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const nav = document.querySelector("ion-nav");

    const providers: TopUpProvider[] = useAppSelector((state) => state.toUpProviders);

    // Close function to dismiss the modal and return to TopupRecipient
    // const close = useCallback(() => {
    //     dispatch(closeModal());
    // }, [dispatch]);

    const goToTopUpProducts = useCallback(async (selectedProvider: TopUpProvider) => {
        dispatch(setSeletedTopUpProvider(selectedProvider));
        nav?.push(() => <TopupProduct />)
    }, [dispatch, nav]);

    useEffect(() => {
        const init = async () => {
            try {
                // Fetch provider status in background without blocking UI
                const updatedProviders = await Promise.all(
                    providers.map(async (provider) => {
                        try {
                            const response = await dispatch(
                                ebioroApi.endpoints.getToUpProviderStatus.initiate({ 
                                    provider_codes: provider.provider_code 
                                })
                            ).unwrap();
    
                            return {
                                ...provider,
                                processing_transfers: response.IsProcessingTransfers,
                            };
                        } catch (error) {
                            Sentry.captureException(error);
                            // Return provider with processing_transfers enabled as fallback
                            return {
                                ...provider,
                                processing_transfers: true,
                            };
                        }
                    })
                );
    
                dispatch(setTopUpProviders(updatedProviders));
            } catch (error) {
                Sentry.captureException(error);
            }
        };

        init();
    }, [dispatch]); // Only depend on dispatch, which is stable

    return (
        <IonPage>

            <IonHeader className="ion-no-border">

                <IonToolbar style={{ marginTop: "0%" }}>
                    <IonButtons slot='start'>
                        <IonButton onClick={()=>nav?.pop()} color="primary">
                            <IonIcon slot='start' icon={arrowBackOutline} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle> {t('topups_providers.page.HEADER') as string}</IonTitle>
                </IonToolbar>

            </IonHeader>
            <IonContent>
                <IonCard className="ion-padding topup_provider_card">
                    <IonCardContent>
                       
                            {providers.map((item, index) => (
                                <IonItem
                                    lines="none"
                                    key={item.provider_code}
                                    onClick={() => goToTopUpProducts(item)}
                                    button
                                    disabled={item.processing_transfers === false}
                                >
                                    <IonGrid className="ion-text-center">
                                        <IonRow className="ion-align-items-center">
                                            <IonCol size="2" className="ion-align-self-center">
                                                <IonThumbnail>
                                                    <IonImg className="topup_provider_img" src={item.logo_url} />
                                                </IonThumbnail>
                                            </IonCol>

                                            <IonCol className="ion-align-self-center">
                                                <IonLabel>
                                                    {item.provider_code === '1HCU' ? (
                                                        <h4>{t('topups_providers.page.CUBACEL_RECHARGE_TUR')}</h4>
                                                    ) : item.provider_code === 'CUCU' ? (
                                                        <h4>{t('topups_providers.page.CUBACEL_RECHARGE_STANDARD')}</h4>
                                                    ) : item.provider_code === 'DFCU' ? (
                                                        <h4>{t('topups_providers.page.CUBACEL_RECHARGE_BUNDLE')}</h4>
                                                    ) : (
                                                        <h4>{item.name}</h4>
                                                    )}
                                                </IonLabel>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                </IonItem>
                            ))}
                      
                    </IonCardContent>
                </IonCard>



            </IonContent>
        </IonPage>
    )

}

const TopupProvider: React.FC = () => (
    <Provider store={store}>
        <Page />
    </Provider>
);

export default TopupProvider;